import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_USERS,
  REQUEST_CREATE_MASTER_USERS,
  SET_MASTER_USERS,
  SUCCESS_CREATE_MASTER_USERS,
  ERROR_GET_MASTER_USERS,
  ERROR_CREATE_MASTER_USERS,
  SET_MESSAGE_MASTER_USERS,
  SUCCESS_DELETE_MASTER_USERS,
  SUCCESS_UPDATE_MASTER_USERS,
  REQUEST_DELETE_MASTER_USERS,
  REQUEST_UPDATE_MASTER_USERS,
  ERROR_DELETE_MASTER_USERS,
  ERROR_UPDATE_MASTER_USERS,
} from "./userstActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterUsers: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterUsers: [],
};

const users = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_USERS:
    case REQUEST_CREATE_MASTER_USERS:
    case REQUEST_DELETE_MASTER_USERS:
    case REQUEST_UPDATE_MASTER_USERS:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_USERS:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_USERS:
      return {
        ...state,
        busy: false,
        message: "",
        masterUsers: action.payload,
      };

    case SUCCESS_CREATE_MASTER_USERS:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterUsers: [...state.masterUsers, action.payload],
      };
    case SUCCESS_DELETE_MASTER_USERS:
      return {
        ...state,
        busy: false,
        message: "",
        masterUsers: state.masterUsers.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_USERS:
      return {
        ...state,
        busy: false,
        message: "",
        masterUsers: state.masterUsers.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_USERS:
    case ERROR_CREATE_MASTER_USERS:
    case ERROR_UPDATE_MASTER_USERS:
    case ERROR_DELETE_MASTER_USERS:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default users;

export function useUsersMaster() {
  return useSelector((state: Record<string, any>) => state.users);
}
